import { createSlice } from "@reduxjs/toolkit";

let initialState = {
  open: false,
};

const CommonSlice = createSlice({
  name: "Common",
  initialState,
  reducers: {
    OpenDrawer(state) {
      // Drawer 열림
      state.open = true;
    },
  },
});

export default CommonSlice.reducer;
export const CommonActions = CommonSlice.actions;
